export enum FeedbackRateType {
  SAD = 1,
  HAPPY = 5,
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback-rate/feedback-rate-types.ts